import React, { useState } from 'react';

// FAQ数据
const faqData = {
  questions: [
    {
      id: 1,
      question: '手链太紧怎么办？',
      answer: '如果手链太紧，可以尝试以下方法：1. 重新制作，增加珠子数量；2. 使用弹性更大的线材；3. 添加延长链；4. 调整扣子位置。',
      category: '制作问题'
    },
    {
      id: 2,
      question: '如何防止珠子脱落？',
      answer: '防止珠子脱落的方法：1. 使用合适的线材，确保线材强度足够；2. 打结时要牢固，建议打双结；3. 定期检查手链，及时更换损坏的线材；4. 避免手链受到剧烈拉扯。',
      category: '保养问题'
    },
    {
      id: 3,
      question: '什么是咪数？',
      answer: '咪数是珠宝行业常用的长度单位，1咪=1毫米，通常用于表示珠子的直径。例如，8咪的珠子直径就是8毫米。',
      category: '术语解释'
    },
    {
      id: 4,
      question: '什么是弹性系数？',
      answer: '弹性系数是指线材的弹性程度，弹性系数越高，线材的拉伸能力越强。制作手链时，需要根据珠子的重量和设计需求选择合适弹性系数的线材。',
      category: '术语解释'
    },
    {
      id: 5,
      question: '如何清洁水晶手链？',
      answer: '清洁水晶手链的方法：1. 使用温水和温和的肥皂水清洗；2. 用软布轻轻擦拭；3. 避免使用化学清洁剂；4. 清洗后用软布擦干，放在通风处晾干。',
      category: '保养问题'
    }
  ],
  categories: ['制作问题', '保养问题', '术语解释']
};

const FAQ = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [filteredQuestions, setFilteredQuestions] = useState(faqData.questions);

  // 过滤问题
  const filterQuestions = () => {
    let filtered = faqData.questions;
    
    // 按分类过滤
    if (selectedCategory) {
      filtered = filtered.filter(question => question.category === selectedCategory);
    }
    
    // 按搜索词过滤
    if (searchTerm) {
      filtered = filtered.filter(question => 
        question.question.includes(searchTerm) || 
        question.answer.includes(searchTerm)
      );
    }
    
    setFilteredQuestions(filtered);
  };

  // 处理搜索变化
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    filterQuestions();
  };

  // 处理分类变化
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    filterQuestions();
  };

  // 切换问题展开/收起
  const toggleQuestion = (questionId) => {
    setExpandedQuestion(expandedQuestion === questionId ? null : questionId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          常见问题与术语解释
        </h1>
        
        {/* 搜索和分类 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-purple-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">
                搜索
              </label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="输入关键词搜索..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="w-full px-4 py-2 pl-12 rounded-lg border border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                />
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                  🔍
                </div>
              </div>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">
                分类筛选
              </label>
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="w-full px-4 py-2 rounded-lg border border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              >
                <option value="">全部分类</option>
                {faqData.categories.map((category, index) => (
                  <option key={index} value={category}>{category}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* FAQ列表 */}
        <div className="space-y-4">
          {filteredQuestions.length > 0 ? (
            filteredQuestions.map((question) => (
              <div key={question.id} className="bg-white rounded-xl shadow-lg border border-purple-100 overflow-hidden">
                <div 
                  className="p-6 cursor-pointer flex items-center justify-between"
                  onClick={() => toggleQuestion(question.id)}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-800 font-bold">
                      ?
                    </div>
                    <h3 className="text-lg font-semibold text-purple-700">
                      {question.question}
                    </h3>
                  </div>
                  <div className={`transform transition-transform duration-300 ${
                    expandedQuestion === question.id ? 'rotate-180' : ''
                  }`}>
                    ▼
                  </div>
                </div>
                {expandedQuestion === question.id && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 pl-12">{question.answer}</p>
                    <div className="mt-3 pl-12">
                      <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
                        {question.category}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="bg-white rounded-xl shadow-lg p-8 text-center border border-purple-100">
              <p className="text-gray-600">未找到匹配的问题</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQ;